import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { ApAgingReport, SupplierStatement } from '../interfaces/procurement/supplierReport.interface';

export const SupplierReportService = {
  aging: async (institutionId: string): Promise<ApAgingReport> =>
    (await axios.get(ENDPOINTS.SUPPLIER_REPORT.AGING(institutionId))).data,
  statement: async (supplierId: string, from: string, to: string): Promise<SupplierStatement> =>
    (await axios.get(ENDPOINTS.SUPPLIER_REPORT.STATEMENT(supplierId, from, to))).data,
};
